<template>
    <el-table
        v-loading="status == 'loading'"
        :data="datas"
        style="width: 100%"
        empty-text="沒有資料"
        class="accounting-summary-table accounting-bank-transfer-table"
        :height="maxHeight"
        border
        @selection-change="$emit('selected', $event)"
        @row-click="onRowClick"
    >
        <el-table-column type="selection" width="42" fixed></el-table-column>
        <el-table-column label="系統單號" width="100" align="left" fixed>
            <template slot-scope="scope">
                <span @click="$event => onClick($event, scope.row.sno)" style="font-size: 8.5pt;">{{ scope.row.systemNo }}</span>
            </template>
        </el-table-column>
        <el-table-column label="財會檢核" align="left" width="80" fixed>
            <template slot-scope="scope">
                <AccountingStatusLabel :statusNum="scope.row.vocherStatus" />
            </template>
        </el-table-column>
        <el-table-column label="核准傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{'blur-zero' : scope.row.approvedVocherQty === 0}">{{ scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="待辦傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.vocherQty - scope.row.approvedVocherQty === 0 }">{{ scope.row.vocherQty - scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="sourceBankName" label="轉出帳號" class-name="blue strong" width="150" />
        <el-table-column prop="transferDate" label="轉出日期" class-name="blue" width="100" align="center">
            <template slot-scope="scope">
                <div>{{ scope.row.transferDate | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="sourceAmt" label="轉出金額" class-name="blue strong" align="right" width="90">
            <template slot-scope="scope">
                <Money :v="scope.row.sourceAmt" />
            </template>
        </el-table-column>
        <el-table-column prop="sourceCny" label="幣別" class-name="blue" width="60" align="center" />
        <el-table-column prop="sourceRate" label="轉出匯率" class-name="blue strong" align="right" width="75">
            <template slot-scope="scope">
                <Money :v="scope.row.sourceRate" />
            </template>
        </el-table-column>
        <el-table-column prop="sourceFee" label="轉出匯費" class-name="blue strong " align="right" width="75">
            <template slot-scope="scope">
                <Money :v="scope.row.sourceFee" />
            </template>
        </el-table-column>

        <el-table-column prop="targetBankName" label="轉入帳號" class-name="yellow strong" width="150" />
        <el-table-column prop="transferDate" label="轉入日期" class-name="yellow" width="100" align="center">
            <template slot-scope="scope">
                <div>{{ scope.row.transferDate | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="targetAmt" label="轉入金額" class-name="yellow strong" align="right" width="90">
            <template slot-scope="scope">
                <Money :v="scope.row.targetAmt" />
            </template>
        </el-table-column>
        <el-table-column prop="targetCny" label="幣別" class-name="yellow" width="60" align="center" />
        <el-table-column prop="targetRate" label="轉入匯率" class-name="yellow strong" align="right" width="75">
            <template slot-scope="scope">
                <Money :v="scope.row.targetRate" />
            </template>
        </el-table-column>
        <el-table-column prop="targetFee" label="轉入匯費" class-name="yellow strong" align="right" width="75">
            <template slot-scope="scope">
                <Money :v="scope.row.targetFee" />
            </template>
        </el-table-column>

        <el-table-column label="成單日期" width="120">
            <template slot-scope="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';
import { PAY_WAY_LIST } from '@/assets/commonData/options';
import AccountingTableMixins from '../AccountingTableMixins.vue';

export default {
    mixins: [AccountingTableMixins],
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    components: { AccountingStatusLabel },
    methods: {
        onClick(e, sno) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('openReceipt', sno);
        },
        onRowClick(data) {
            this.$emit('openDetail', data.sno, data.vocherStatus);
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
    },
};
</script>

<style lang="scss">
.accounting-bank-transfer-table {
    .el-table__body-wrapper {
        // height: 550px;
    }
    .blue {
        background-color: #f1f4ff;
    }
    .yellow {
        background-color: #fffde7;
    }
    .red {
        background-color: #fff5f5;
    }

    .el-table__row {
        cursor: pointer;
    }
    .cny {
        font-size: 9pt;
    }
}
</style>
